<template>
  <div>
    <el-row>
      <el-col :span='3'>
        <div class='grid-content1'></div>
      </el-col>
      <el-col :span='18'>
        <div class='grid-content1'>
          <div style='height: 220px'>
            <ul style='padding-top: 30px'>
              <!--三主营业务-->
              <li v-for='item in businessListData' :key='item.id' class='mainBusiness'>
                <h2>主营业务-{{ item.typeName }}</h2>
                <ul>
                  <li v-for='item1 in item.children' :key='item1.id'>
                    <a @click='jumpBusiness(item1)'>{{ item1.name }}</a>
                  </li>
                </ul>
              </li>

              <!--地址及二维码-->
              <!--地址-->
              <li class='address'>
                <div class='businessAddress'>
                  <i class='el-icon-location-information'></i>
                  <span>{{ this.tableData.address }}</span>
                </div>
                <div class='qrCode'>
                  <el-image class='imgs' v-if='tableData.uploadImgAbsolutePath != null'
                            :src='imageUrl'
                            alt='logo'
                            :preview-src-list='imageList1'
                  ></el-image>
                  <p >官方公众号</p>
                </div>
                <div class='qrCode'>
                  <el-image class='imgs' v-if='tableData.uploadImgAbsolutePath1 != null'
                            :src='imageUrl1'
                            alt='logo'
                            :preview-src-list='imageList2'
                  ></el-image>
                  <p >官方抖音号</p>
                </div>
              </li>
              <!-- 电话、商务合作-->
              <li class='telephone'>
                <div class='enterpriseTelephone'>
                  <i class='el-icon-phone-outline'></i>
                  <span>{{ this.tableData.phone }}</span>
                </div>
                <div class='businessCooperation'>
                  <p>商务合作</p>
                  <ul>
                    <li v-for='item in liaiseListData' :key='item.id'>
                      <p>{{ item.name }} {{ item.phone }}</p>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </el-col>
      <el-col :span='3'>
        <div class='grid-content1'></div>
      </el-col>
    </el-row>
    <el-row>
      <!--友情链接、版本号-->
      <el-col :span='3'>
        <div class='Links'></div>
      </el-col>
      <el-col :span='18'>
        <div class='Links'>
          <ul>
            <li v-for='item in tableListData' :key='item.id'>
              <a @click='jump(item)'>{{ item.name }}</a>
            </li>
            <li class='putOnRecord' @click='skipOlick()'>{{ this.tableData.filings }}</li>
          </ul>
        </div>
      </el-col>
      <el-col :span='3'>
        <div class='Links'></div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { linksList, selectConfig, webBusinessList, liaiseList } from '../../api/auth'
import A from './index.vue'

export default {
  created () {
    this.webConfig()
    this.getList()
    this.liaiseList()
    this.webBusinessList()
  },
  data () {
    return {
      tableListData: [],
      businessListData: [],
      liaiseListData: [],
      imageList1: [],
      imageUrl: '',
      imageList2: [],
      imageUrl1: '',
      tableData: {
        legacyPortal: '',
        address: '',
        phone: '',
        fax: '',
        email: '',
        imageUrl: '',
        dyImageUrl: '',
        filings: '',
        numberTrainees: '',
        numberCooperation: '',
        serviceAmount: '',
        uploadImgAbsolutePath: '',
        uploadImgAbsolutePath1: ''

      },
      queryParams: {}
    }
  },
  methods: {
    /** 友情链接列表 */
    getList () {
      let that = this
      linksList(this.queryParams).then(res => {
        that.tableListData = res
      })
    },
    skipOlick () {
      window.open('https://beian.miit.gov.cn/', '_blank')
    },
    /** 商务合作联系人 */
    liaiseList () {
      let that = this
      liaiseList(this.queryParams).then(res => {
        that.liaiseListData = res
      })
    },
    /** 查询主营业务 */
    webBusinessList () {
      let that = this
      webBusinessList(this.queryParams).then(res => {
        that.businessListData = res
      })
    },
    /** 跳转 */
    jump (raw) {
      window.open(raw.url, '_blank')
    },
    /** 跳转 */
    jumpBusiness (raw) {
      // A.methods.say(raw.name)
      this.$router.push({
        path: '/index',
        query: {
          type: '100',
          say: raw.name
        }
      })
      window.location.reload()
    },
    /** 查询网站配置 */
    webConfig () {
      let that = this
      selectConfig(this.queryParams).then(res => {
        that.tableData.address = res.address
        that.tableData.phone = res.phone
        that.tableData.fax = res.fax
        that.tableData.email = res.email
        that.tableData.imageUrl = res.imageUrl
        that.tableData.dyImageUrl = res.dyImageUrl
        that.tableData.filings = res.filings
        that.tableData.legacyPortal = res.legacyPortal
        that.tableData.numberTrainees = res.numberTrainees
        that.tableData.numberCooperation = res.numberCooperation
        that.tableData.serviceAmount = res.serviceAmount
        that.tableData.uploadImgAbsolutePath = res.imageUrl
        that.tableData.uploadImgAbsolutePath1 = res.dyImageUrl

        if (this.tableData.uploadImgAbsolutePath != null) {
          this.imageUrl = this.$baseUrl + '/upload/loadFileStreamByPath?path=' + encodeURIComponent(this.tableData.uploadImgAbsolutePath)
        }
        this.imageList1 = []
        if (this.tableData.uploadImgAbsolutePath != null) {
          this.imageList1.push(this.$baseUrl + '/upload/loadFileStreamByPath?path=' + encodeURIComponent(this.tableData.uploadImgAbsolutePath))
        }
        if (this.tableData.uploadImgAbsolutePath1 != null) {
          this.imageUrl1 = this.$baseUrl + '/upload/loadFileStreamByPath?path=' + encodeURIComponent(this.tableData.uploadImgAbsolutePath1)
        }
        this.imageList2 = []
        if (this.tableData.uploadImgAbsolutePath1 != null) {
          this.imageList2.push(this.$baseUrl + '/upload/loadFileStreamByPath?path=' + encodeURIComponent(this.tableData.uploadImgAbsolutePath1))
        }
      })
    }
  }
}
</script>

<style lang='less' scoped>
.el-row {
  background-color: #eee;

  &:last-child {
    margin-bottom: 0;
  }
}

.grid-content1 {
  height: 300px;
  background-color: #11a84e;

  ul {
    .mainBusiness {
      width: 18%;
      display: block;
      float: left;

      h2 {
        font-size: 1rem;
        font-family: "MicrosoftYaHei";
        color: #eee;
        padding-bottom: 5px;
      }

      li {
        font-size: 13px;
        font-family: "MicrosoftYaHei";
        line-height: 22px;
        a{
          color: #eee !important;
        }
      }
    }

    .address {
      width: 28%;
      display: block;
      float: left;
      .businessAddress {
        min-width: 100%;
        padding: 2px 10px;
        float: right;
        border-radius: 30px;
        background-color: #11a84e;
        color: #eee;
        i {
          padding-right: 5px;
        }
        span{
          font-size: 14px;
          font-family: "MicrosoftYaHei";
        }
      }

      .qrCode {
        width: 50%;
        margin-top: 50px;
        float: left;
        color: #fff;
        .imgs{
          width: 100px;
          height: 100px;
          display: block;
          margin: 8px auto;
          background-color: #fff;
        }

        p {
          text-align: center;
          font-size: 14px;
          font-family: "MicrosoftYaHei";
        }
      }
    }

    .telephone {
      width: 18%;
      display: block;
      float: right;
      color: #eee;
      .enterpriseTelephone {
        padding: 2px 10px;
        float: right;
        min-width: 87%;
        max-width: 100%;
        border-radius: 30px;
        color: #eee;

        i {
          padding-right: 5px;
        }
      }
    }

    .businessCooperation {
      font-size: 14px;
      font-family: "MicrosoftYaHei";
      line-height: 30px;
      padding-left: 45px;
      margin-top: 50px;
    }
  }
}

.Links {
  height: 50px;
  background-color: #11a84e;
  li {
    margin-top: 15px;
    display: block;
    float: left;
    margin-right: 20px;
    color: #eee;
    a {
      color: #eee;
    }

    a:hover {
      color: #eee;
    }
  }

  .putOnRecord {
    float: right;
  }
}
</style>
